import JsonControl from './json_control.js'

export default class CarouselControl extends JsonControl {
  get block () {
    return this.selection.block.closest('.carousel')
  }
}